<template>
    <section
        class="highlight-image"
        :style="generateStylingVariables(content.style)"
    >
        <div class="highlight-image__body">
            <div class="highlight-image__info-list">
                <div
                    v-for="(item, index) in content.orbs"
                    :key="index"
                    class="highlight-image__info container container--only-mobile"
                    :class="{
                        [`highlight-image__info--${index + 1}`]: true,
                    }"
                >
                    <zoe-atom-text
                        class="highlight-image__info-text"
                        :item="item.text.value"
                    />
                </div>
            </div>

            <zoe-atom-text
                v-if="stringIsNotEmpty(content.content.value)"
                :item="content.content.value"
                class="highlight-image__content"
            />

            <button
                v-if="stringIsNotEmpty(content.button.value)"
                class="highlight-image__button button"
                @click="buttonClick"
            >
                <zoe-atom-text
                    class="label"
                    :item="content.button.value"
                />
            </button>
        </div>

        <div
            class="highlight-image__image-wrapper"
            :class="{
                [`highlight-image__image-wrapper--size-${content.imageSize.value}`]: true,
            }"
        >
            <zoe-atom-media
                class="highlight-image__image"
                :item="content.image.value"
            />

            <div class="highlight-image__items">
                <div
                    v-for="(item, index) in content.orbs"
                    :key="index"
                    class="highlight-image__item"
                    :class="{
                        [`highlight-image__item--${index + 1}`]: true,
                        [`highlight-image__item--position-${getItemPosition(item)}`]: true,
                    }"
                    tabindex="0"
                    :style="{
                        '--top': item.position.top.value,
                        '--left': item.position.left.value,
                    }"
                >
                    <div class="highlight-image__item-orb" />

                    <div class="highlight-image__item-highlight">
                        <zoe-atom-text
                            class="highlight-image__item-highlight-text"
                            :item="item.text.value"
                        />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
import ZoeAtomText from '@atoms/text/v1.0.0/zoe-atom-text.vue';
import ZoeAtomMedia from '@atoms/media/v1.0.0/zoe-atom-media.vue';
import { componentProps } from '../../../../../../resources/mixins/component/component';
import { getValue, stringIsNotEmpty } from '../../../../../../../resources/frontend/js/mixins/get-page-data';
import { generateStylingVariables } from '../../../../../../resources/mixins/styling/styling';
import scrollToSelector from '../../../../../../resources/mixins/utils/scroll-to-selector';

const props = defineProps({...componentProps});

const imageSizes = {
    regular: {
        width: 616,
        height: 427,
    },

    fullSize: {
        width: 1000,
        height: 640,
    },

    vertical: {
        width: 496,
        height: 663,
    },
};

const buttonClick = () => {
    const scrollOffset = getValue('general.logobar.position') === 'fixed' ? -160 : -60;

    scrollToSelector('.step__flow', scrollOffset);
};

const getItemPosition = item => {
    const left = item.position.left.value;
    const top = item.position.top.value;
    const imageSize = imageSizes[props.content.imageSize.value];

    if (left < 120) {
        return 'right';
    }

    if (left > imageSize.width - 120) {
        return 'left';
    }

    if (top < 120) {
        return 'bottom';
    }

    if (top > imageSize.height - 120) {
        return 'top';
    }

    return 'bottom';
};
</script>

<style lang="scss">
@use 'step-highlight-image';
</style>

<style lang="scss" scoped>
@layer step {
    .highlight-image {
        --image-width: v-bind('imageSizes[props.content.imageSize.value].width');
        --image-height: v-bind('imageSizes[props.content.imageSize.value].height');
    }
}
</style>
